<div>
    <ng-container *ngIf="loading">
        <div class="loading text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading, please wait...</p>
        </div>
    </ng-container>

    <div *ngIf="!loading" id="questions" class="tab-pane fade in active">
        <!--<div class="row">-->
            <!--<div class="col-sm-9 table-actions">
                <div (click)="takeAssessmentSelected()" [ngClass]="{'icon_disabled': canTakeAssessment == false}">
                    <i class="material-icons rotate180" [ngClass]="{'icon_disabled': canTakeAssessment == false}">keyboard_backspace</i>
                    <span>Take</span>
                </div>

                <div (click)="ratersModal()" [ngClass]="{'icon_disabled': is360 == false}">
                    <i class="material-icons" [ngClass]="{'icon_disabled': is360 == false}">group</i>
                    <span>Assign</span>
                </div>
            </div>-->

            <!--<div class="col-sm-3 text-right table-actions-buttons">
            <button type="button" class="btn btn-warning">
                Create
            </button>
        </div>-->
        <!--</div>-->

        <!--<div class="btns-container" style="position:absolute;top:15px;right:0px;">
            <!--<a (click)="ratersModal()" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5" [ngClass]="{'btn-other': is360, 'btn-gray': !is360}">
                <i class="fas fa-plus text-white-50"> <span class="button-text"> Assign raters</span></i>
            </a>-->
            <!--<a (click)="takeAssessmentSelected()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" [ngClass]="{'btn-primary': canTakeAssessment, 'btn-gray': !canTakeAssessment}">
                <i class="fas fa-arrow-right text-white-50"> <span class="button-text">Begin assessment</span></i>
            </a>-->
        <!--</div>-->

        <div style="width: 100%; max-height: 400px; height:400px;">
            <ag-grid-angular #pendingAgGrid 
                             style="width: 100%; height: 100%;" 
                             class="ag-theme-balham" 
                             [enableFilter]="true" 
                             [floatingFilter]="true"
                             [gridOptions]="gridOptions" 
                             [rowData]="assessments" 
                             [columnDefs]="assessmentsHeaders" 
                             [enableSorting]="true" 
                             [enableColResize]="true" 
                             (rowClicked)="onRowClicked($event)"
                             (gridReady)="onGridReady($event)" 
                             [pagination]="true" 
                             [paginationPageSize]="25" 
                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"> 
                             <!--[rowSelection]="rowSelection" 
                             (rowSelected)="onRowSelected($event)" 
                             (selectionChanged)="onSelectionChanged($event)">-->
            </ag-grid-angular>
        </div>
    </div>
</div>


<!-- RATERS MODAL -->
<div id="ratersModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <p class="text-center">You will need to select 3 rater minimun except Manager Category</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12 text-right" style="padding-right: 0px !important">
                        <i (click)="showNewRaterModal()" class="material-icons">add</i>
                    </div>
                </div>

                <div class="" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #agGrid style="width: 100%; height: 100%;" class="ag-theme-balham" [enableFilter]="true" [gridOptions]="gridOptions" [rowData]="raters" [columnDefs]="ratersHeaders" [enableSorting]="true" [enableColResize]="true" (rowClicked)="onRowClicked($event)"
                        (gridReady)="onGridReadyModal($event)" [pagination]="true" [paginationPageSize]="25" [overlayNoRowsTemplate]="overlayNoRowsTemplate" [animateRows]="true" [rowDragManaged]="true" [rowMultiSelectWithClick]="true" [rowSelection]="rowSelection">
                    </ag-grid-angular>
                </div>
            </div>

            <!--<div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="saveRater()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>-->

        </div>
    </div>
</div>

<!--NEW RATER MODAL-->
<div id="addModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add Rater</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Email:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #email id="email" type="email" placeholder="Email" [(ngModel)]="rater.email" (keypress)="preventSpace(email.value, $event, 'email')" (keyup)="preventSpace(email.value, $event, 'email')" />
                    </div>
                </div>

                <!--<div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>First Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #firstName
                               id="firtName"
                               type="text"
                               placeholder="First name"
                               [(ngModel)]="rater.firstName"
                               (keypress)="preventSpace(firstName.value, $event, 'firtName')"
                               (keyup)="preventSpace(firstName.value, $event, 'firtName')" />
                    </div>
                </div>-->
                <!--<div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Last name:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #lastName
                               id="lastName"
                               type="text"
                               placeholder="Last name"
                               [(ngModel)]="rater.lastName"
                               (keypress)="preventSpace(firstName.value, $event, 'lastName')"
                               (keyup)="preventSpace(firstName.value, $event, 'lastName')" />
                    </div>
                </div>-->

                <div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Relationship:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <select id="raterTypesSelect" #raterType [(ngModel)]="rater.raterType">
                            <option *ngFor="let rt of raterTypes" value="{{rt.Id}}">{{rt.Name}}</option>
                        </select>
                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeNewRaterModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="saveRater()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>